import { defineStore } from 'pinia'
import { setLocal } from '@/common/js/utils'
import { getLocal } from '@/common/js/utils'
import usePage from '@/hooks/usePage'

const { isMiniProgram } = usePage()
export const useAppStore = defineStore({
  id: 'app',
  state: () => ({
    platform: null
  }),
  getters: {
    getPlatform() {
      return this.platform || getLocal('platform')
    },
    isInWxapp() {
      return this.getPlatform === 'mini'
    }
  },
  actions: {
    async setPlatform() {
      const isInWxapp = await isMiniProgram()
      if (isInWxapp) {
        this.platform = 'mini'
        setLocal('platform', this.platform)
      }
    }
  }
})
